import SiteHeader from "@/pages/home/components/SiteHeader";
import HeroSection from "@/pages/home/components/HeroSection";
import EntrySection from "@/pages/home/components/EntrySection";
import TroubleshootSection from "@/pages/home/components/TroubleshootSection";
import TrustSection from "@/pages/home/components/TrustSection";
import CollectSection from "@/pages/home/components/CollectSection";
import FaqSection from "@/pages/home/components/FaqSection";
import SiteFooter from "@/pages/home/components/SiteFooter";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <SiteHeader />
      <main>
        <HeroSection />
        <EntrySection />
        <TroubleshootSection />
        <TrustSection />
        <CollectSection />
        <FaqSection />
      </main>
      <SiteFooter />
    </div>
  );
}